if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {

      constructor() {
        super();

        this.input =
          this.querySelector(
            '.quantity__input'
          );

        this.currentVariant =
          this.querySelector(
            '.product-variant-id'
          );

        this.submitButton =
          this.querySelector(
            '[type="submit"]'
          );

        this.cartUpdateUnsubscriber =
          undefined;

        this.variantChangeUnsubscriber =
          undefined;

        this.quantityRequestController =
          null;

        this.fetchQuantityRulesDebounced =
          debounce(
            this.fetchQuantityRules.bind(
              this
            ),
            120
          );
      }


      connectedCallback() {

        if (!this.input) return;

        this.quantityForm =
          this.querySelector(
            '.product-form__quantity'
          );

        if (!this.quantityForm) return;

        this.setQuantityBoundries();


        if (
          !this.dataset.originalSection
        ) {

          this.cartUpdateUnsubscriber =
            subscribe(
              PUB_SUB_EVENTS.cartUpdate,
              this
                .fetchQuantityRulesDebounced
            );
        }


        this.variantChangeUnsubscriber =
          subscribe(
            PUB_SUB_EVENTS.variantChange,
            (event) => {

              const sectionId =
                this.dataset
                  .originalSection ||
                this.dataset.section;

              if (
                event.data.sectionId !==
                sectionId
              ) {
                return;
              }

              this.updateQuantityRules(
                event.data.sectionId,
                event.data.html
              );

              this.setQuantityBoundries();

            }
          );
      }


      disconnectedCallback() {

        this.cartUpdateUnsubscriber?.();

        this.variantChangeUnsubscriber?.();


        this.cartUpdateUnsubscriber =
          undefined;

        this.variantChangeUnsubscriber =
          undefined;


        this.quantityRequestController
          ?.abort();

        this.quantityRequestController =
          null;
      }


      setQuantityBoundries() {

        if (!this.input) return;


        const cartQuantity =
          Number.parseInt(
            this.input.dataset
              .cartQuantity || '0',
            10
          ) || 0;


        const min =
          Number.parseInt(
            this.input.dataset.min ||
              '1',
            10
          ) || 1;


        const maxRaw =
          this.input.dataset.max;


        const max =
          maxRaw
            ? Number.parseInt(
                maxRaw,
                10
              )
            : null;


        const step =
          Number.parseInt(
            this.input.step || '1',
            10
          ) || 1;


        let nextMin = min;


        const availableMax =
          max === null
            ? null
            : max - cartQuantity;


        if (
          availableMax !== null
        ) {
          nextMin = Math.min(
            nextMin,
            availableMax
          );
        }


        if (
          cartQuantity >= min
        ) {
          nextMin = Math.min(
            nextMin,
            step
          );
        }


        this.input.min = nextMin;


        if (
          availableMax !== null &&
          availableMax > 0
        ) {

          this.input.max =
            availableMax;

        } else {

          this.input.removeAttribute(
            'max'
          );
        }


        this.input.value = nextMin;


        publish(
          PUB_SUB_EVENTS.quantityUpdate,
          undefined
        );
      }


      async fetchQuantityRules() {

        if (
          !this.currentVariant?.value ||
          !this.dataset.url ||
          !this.dataset.section
        ) {
          return;
        }


        const spinner =
          this.querySelector(
            '.quantity__rules-cart .loading__spinner'
          );


        spinner?.classList.remove(
          'hidden'
        );


        this.quantityRequestController
          ?.abort();


        const controller =
          new AbortController();


        this.quantityRequestController =
          controller;


        try {

          const response =
            await fetch(
              `${this.dataset.url}?variant=${encodeURIComponent(
                this.currentVariant
                  .value
              )}&section_id=${encodeURIComponent(
                this.dataset.section
              )}`,
              {
                signal:
                  controller.signal,

                credentials:
                  'same-origin',
              }
            );


          if (!response.ok) {
            throw new Error(
              `Quantity rules HTTP ${response.status}`
            );
          }


          const responseText =
            await response.text();


          if (
            controller.signal.aborted
          ) {
            return;
          }


          const html =
            new DOMParser()
              .parseFromString(
                responseText,
                'text/html'
              );


          this.updateQuantityRules(
            this.dataset.section,
            html
          );


          this.setQuantityBoundries();


        } catch (error) {

          if (
            error?.name !==
            'AbortError'
          ) {

            console.error(
              'Erro ao atualizar regras de quantidade:',
              error
            );

          }

        } finally {

          if (
            this
              .quantityRequestController ===
            controller
          ) {

            this.quantityRequestController =
              null;

            spinner?.classList.add(
              'hidden'
            );

          }
        }
      }


      updateQuantityRules(
        sectionId,
        html
      ) {

        if (
          !this.quantityForm ||
          !html
        ) {
          return;
        }


        const quantityFormUpdated =
          html.getElementById(
            `Quantity-Form-${sectionId}`
          );


        if (!quantityFormUpdated) {
          return;
        }


        const selectors = [
          '.quantity__input',
          '.quantity__rules',
          '.quantity__label',
        ];


        for (
          const selector of selectors
        ) {

          const current =
            this.quantityForm
              .querySelector(
                selector
              );


          const updated =
            quantityFormUpdated
              .querySelector(
                selector
              );


          if (
            !current ||
            !updated
          ) {
            continue;
          }


          if (
            selector ===
            '.quantity__input'
          ) {

            const attributes = [
              'data-cart-quantity',
              'data-min',
              'data-max',
              'step',
            ];


            for (
              const attribute
              of attributes
            ) {

              const valueUpdated =
                updated.getAttribute(
                  attribute
                );


              if (
                valueUpdated !==
                null
              ) {

                current.setAttribute(
                  attribute,
                  valueUpdated
                );

              } else {

                current
                  .removeAttribute(
                    attribute
                  );

              }
            }

          } else if (
            current.innerHTML !==
            updated.innerHTML
          ) {

            current.innerHTML =
              updated.innerHTML;

          }
        }
      }
    }
  );
}